<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <div style="position: relative">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
        <span style="position: absolute; top: -10px; right: -13px">
          <b-badge
            v-if="item.route === 'service-system' && appStore.serviceBadgeCount['all']"
            pill
            :variant="item.tagVariant || 'primary'"
            class="mr-1 ml-auto"
          >
            {{ appStore.serviceBadgeCount['all'] || 0 }}
          </b-badge>
          <b-badge
            v-else-if="item.tag"
            pill
            :variant="item.tagVariant || 'primary'"
            class="mr-1 ml-auto"
          >
            {{ item.tag }}
          </b-badge>
          <b-badge
            v-else-if="item.resource == 'chatPartner' && item.isHasMessage"
            pill
            :variant="item.tagVariant || 'primary'"
            class="mr-1 ml-auto"
            style="padding: 5px; font-size: 1px; margin-right: 21px !important"
          >.</b-badge>
        </span>
      </div>

      <span
        class="menu-title text-truncate"
        :title="t(item.title)"
      >{{
        t(item.title)
      }}</span>

      <!-- <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge> -->
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useAppStore from '@/store-pinia/useAppStore'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item,
    )
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    const appStore = useAppStore()

    return {
      isActive,
      linkProps,
      updateIsActive,
      appStore,
      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
}
</script>
